export default __webpack_public_path__ + "static/media/climate.0855cc8b.png";